import { createGlobalStyle } from 'styled-components';

import CustomArial from '@/assets/fonts/arial-webfont.ttf';

const VariationsStyles = createGlobalStyle`
  @font-face {
    font-family: 'CustomArial';
    src: url(${CustomArial});
  } 
  
  .generated-images-holder-var36 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  .image-holder-var36 {
    width: 100%;
    display: flex;
    position: relative;
    height: 630px;
  }
  .text-var36 {
    position: absolute;
    width: 100%;
    padding: 0 20px;
    top: 30px;
    bottom: auto;
    font-size: 45px;
    line-height: 1.2;
    text-align: center;
    color: #f3d400;
    font-weight: 700;
    font-family: CustomArial;
    letter-spacing: 1.6px;
    text-shadow: 1px 0 0 #f3d400;
    z-index: 1;
    &--bottom {
      top: auto;
      bottom: 30px;
    }
    p {
      background-color: rgba(0,0,0,0.5);
      display: inline-block;
      margin: 0;
      padding: 14px 39px 16px;
    }
    p.custom-brakes {
      white-space: nowrap;
    }
  }
  .left-image-var36 {
    width: 50%;
    height: 100%;
    object-fit: cover;
    position: relative;
  }
  .right-image-var36 {
    width: 50%;
    height: 100%;
    object-fit: cover;
    position: relative;
  }
  .actual-photo-var36 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
    &--right {
      right: 0;
      left: auto;
    }
    &--top {
      top: 0;
      bottom: auto;
    }
  }
   .break-var36 {
    position: absolute;
    width: 12px;
    height: 100%;
    left: 0;
    background-color: white;
    top: 0;
    right: 0;
    margin-left: calc(50% - 6px);
    &--black {
      background-color: black;
    }
  }
`;

export default VariationsStyles;
